/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_INACTIVE_BOXES = gql`
  query GetInactiveBoxes(
    $filter: InActiveBoxFilterInput
    $options: GetManyOptions
  ) {
    getInactiveBoxes(filter: $filter, options: $options) {
      content {
        _id
        amountPaid
        costumeID
        totalAmount
        paymentStats
        boxStatus
        isActive
        presentation {
          id
          name
          status
          year
        }
        section {
          _id
          id
          name
          maxInvites
          costumeTypes {
            name
            id
          }
        }
        isVIP
        items {
          costumeType {
            id
            name
          }
          costumeFeature {
            id
            name
          }
          costumeAttribute {
            id
            name
          }
          costumeValue {
            id
            name
          }
          isPaid
          paidAmount
          paymentStatus
        }
        referal {
          inviteType
          partition
          sectionOptType
          id
        }
        inactive {
          type
          reason
          date
          resoldToEmail
          resaleReason
          resoldAt
          resoldToUser {
            _id
            email
            firstName
            lastName
          }
        }
        user {
          _id
          vuid
          email
          firstName
          lastName
        }
      }
      count
      limit
      skip
      sort {
        field
        order
      }
    }
  }
`;

export const GET_INACTIVE_BOXES_ADMIN = gql`
  query GetInactiveBoxes(
    $filter: InActiveBoxFilterInput
    $options: GetManyOptions
  ) {
    getInactiveBoxes(filter: $filter, options: $options) {
      content {
        _id
        amountPaid
        costumeID
        totalAmount
        paymentStats
        boxStatus
        isActive
        user {
          _id
          fullName
          firstName
          lastName
          email
          gender
          vuid
          creatorUser {
            email
            fullName
            id
          }
        }
        presentation {
          id
          name
          status
          year
        }
        section {
          _id
          id
          name
          maxInvites
          costumeTypes {
            name
            id
          }
        }
        isVIP
        items {
          costumeType {
            id
            name
          }
          costumeFeature {
            id
            name
          }
          costumeAttribute {
            id
            name
          }
          costumeValue {
            id
            name
          }
          isPaid
          paidAmount
          paymentStatus
        }
        referal {
          inviteType
          partition
          sectionOptType
          id
        }
        inactive {
          type
          reason
          date
          resoldToEmail
          resaleReason
          resoldAt
          user {
            email
            fullName
          }
          resoldToUser {
            _id
            email
            firstName
            lastName
          }
        }
      }
      count
      limit
      skip
      sort {
        field
        order
      }
    }
  }
`;
